/* hod-bundle-builder.js (G.2 rebuild, 8/21)
   Guided kitchen package builder per design_handoff_bundle_builder.
   Data plumbing identical to the legacy builder:
   - products + facet filters: Heroku Storefront proxy (POST {filters, collection})
   - stock lines: window.hodResolveStock (hod-builder-stock, G.4)
   - warranty: LGAP bands from window.HOD_PP_RAW by appliance count + bundle total
   - cart: /cart/add.js items with Bundle ID / Bundle Discount / Stock / ETA
     properties, discount code minted by hod-custom-app, checkout redirect
   - quote: hod-custom-app quote.php
   - quick view: existing HOD QV (custom.js) via .bundle-builder--choose-view
     triggers on cards carrying data-bb-card */
(function () {
  var root = document.getElementById('hodbb');
  if (!root) return;

  var PROXY = 'https://hod-bundle-builder-v2-7254e425a723.herokuapp.com';
  var CUSTOM_APP = 'https://hod-custom-app-v2-591bfca71074.herokuapp.com';
  /* 3.9.3 kitchen merge (9/24): every appliance / extra carries the package _bundle_* contract under
     the hidden parent variant, so the live cart transform folds the bundle into ONE cart line priced
     at the sum of its pieces; the warranty plan stays separate. Quotes never carry it (Shopify runs
     the transform inside draft orders and breaks them — ticket 68851189). */
  /* 9/27: kitchen builds are always separate cart lines (Stas 9/25; the Bundle Discount function counts them
     per "Bundle ID"). The merge code below stays dormant — MERGE is never true. */
  var MERGE = false;
  var PARENT_VID = root.getAttribute('data-bb-parent-vid') || '';
  var PARENT_TITLE = root.getAttribute('data-bb-parent-title') || 'Custom Kitchen Package';
  /* Roadmap I (9/27): 'function' = the Bundle Discount automatic discount prices the build in the cart (no minted
     code, no "Bundle Discount" cart property); 'code' = today's one-use code. Quotes keep the % for quote.php under
     "Quote Bundle ID" so the function ignores draft-order lines. */
  function foldStock(list) { /* the merged line's Stock/ETA: worst piece wins; some in + some backordered = Partial Backorder (hod-stock-engine's package rule) */
    var rank = { in: 0, low: 1, bo: 3, oos: 4 }, worst = null, max = -1, min = 99;
    list.forEach(function (p) { var r = rank[p.stockState] != null ? rank[p.stockState] : 0; if (r > max) { max = r; worst = p; } if (r < min) min = r; });
    if (!worst) return { label: '', text: '' };
    if (max >= 3 && min < 3) return { label: 'Partial Backorder', text: worst.stockText || '' };
    return { label: max >= 3 ? (worst.stockLabel || 'Backorder') : max === 1 ? 'Low Stock' : 'In Stock', text: (max ? worst.stockText : list[0].stockText) || '' };
  } /* v2 (renamed from staging 8/24) quote.php: GraphQL invoice send + zip->tax; old prod app's invoice call is silently broken */

  var CATS = [
    { key: 'range', label: 'Range', kind: 'RANGE', coll: 'ranges' },
    { key: 'hood', label: 'Range Hood', kind: 'RANGE HOOD', coll: 'range-hoods' },
    { key: 'fridge', label: 'Refrigerator', kind: 'REFRIGERATOR', coll: 'refrigerators' },
    { key: 'dish', label: 'Dishwasher', kind: 'DISHWASHER', coll: 'dishwashers' },
    { key: 'micro', label: 'Microwave', kind: 'MICROWAVE', coll: 'microwaves' },
    { key: 'extras', label: 'Extras: Beverage Center, Wine Cooler, Ice Maker', short: 'Extras', kind: 'EXTRAS', coll: 'bundle-builder-extras-v2' }
  ];
  var SLOT_KEYS = ['fridge', 'hood', 'range', 'micro', 'dish'];
  /* facets we hide (brand is fixed; availability/price/stock are noise, and
     multi-valued catalogs like Features/Specs/Material overwhelm the panel).
     The design's curated chip set: Size, Fuel + Gas Type, Trim/Finish,
     Series, Mount Type, Type/Style. */
  var FACET_SKIP = /brand|vendor|availability|price|stock|feature|spec|material/i;
  var FACET_ALLOW = [/^size$/i, /fuel/i, /gas type/i, /^trim$/i, /color|finish/i, /^series$/i, /mount/i, /^type$/i, /^style$/i];
  function facetAllowed(label) {
    for (var i = 0; i < FACET_ALLOW.length; i++) if (FACET_ALLOW[i].test(label || '')) return i;
    return -1;
  }
  /* theme-editor override: lines of "cat: Facet, Facet(v1|v2), Facet(!v1|v2)"
     or "Brand|cat: ..." — (v1|v2) shows only those values, (!v1|v2) hides them */
  var FILTER_MAP = (function () {
    var map = {};
    (root.getAttribute('data-bb-filtermap') || '').split('\n').forEach(function (line) {
      var i = line.indexOf(':');
      if (i < 1) return;
      var key = line.slice(0, i).trim().toLowerCase();
      var list = line.slice(i + 1).split(',').map(function (s) {
        var seg = s.trim(), alias = null;
        var am = seg.match(/^(.*?)\s+as\s+(.+)$/i);
        if (am) { seg = am[1].replace(/\s+$/, ''); alias = am[2].trim(); }
        var m = seg.match(/^([^(]+?)\s*\(([^)]*)\)\s*$/);
        if (!m) return { name: seg.toLowerCase(), allow: null, block: null, alias: alias };
        var vals = m[2].replace(/^!/, '').split('|').map(function (v) { return v.trim().toLowerCase(); }).filter(Boolean);
        return m[2].charAt(0) === '!'
          ? { name: m[1].trim().toLowerCase(), allow: null, block: vals, alias: alias }
          : { name: m[1].trim().toLowerCase(), allow: vals, block: null, alias: alias };
      }).filter(function (e) { return e.name; });
      if (key && list.length) map[key] = list;
    });
    return map;
  })();
  function facetRule(cat, label) {
    var list = FILTER_MAP[(S.brand || '').toLowerCase() + '|' + cat] || FILTER_MAP[cat];
    var l = (label || '').trim().toLowerCase();
    if (list) {
      for (var i = 0; i < list.length; i++) if (list[i].name === l) return { idx: i, allow: list[i].allow, block: list[i].block, alias: list[i].alias };
      return { idx: -1 };
    }
    if (FACET_SKIP.test(label || '')) return { idx: -1 };
    return { idx: facetAllowed(label) };
  }
  function facetIdx(cat, label) { return facetRule(cat, label).idx; }
  var HELP_BY_FACET = [
    [/fuel/i, 'fuel'], [/cfm/i, 'cfm']
  ];

  var S = {
    brand: null, brandEl: null, view: null,
    picks: {},            /* catKey -> pick object */
    facetVals: {},        /* catKey -> { facetLabel: cached values } */
    xtra: [],             /* extras picks (multiple allowed) */
    chips: {},            /* catKey -> { facetLabel: inputJson } */
    warr: null,           /* null | 0 | 3 | 5 */
    warrPick: null,       /* {id, price, year} resolved for current total */
    added: false,
    fetchSeq: 0
  };

  var els = {
    brandpill: root.querySelector('[data-bb-brandpill]'),
    brandname: root.querySelector('[data-bb-brandname]'),
    slotcount: root.querySelector('[data-bb-slotcount]'),
    canvasprice: root.querySelector('[data-bb-canvasprice]'),
    overview: root.querySelector('[data-bb-overview]'),
    panel: root.querySelector('[data-bb-panel]'),
    rows: root.querySelector('[data-bb-rows]'),
    warr: root.querySelector('[data-bb-warr]'),
    addedcount: root.querySelector('[data-bb-addedcount]'),
    filters: root.querySelector('[data-bb-filters]'),
    prods: root.querySelector('[data-bb-prods]'),
    matchlabel: root.querySelector('[data-bb-matchlabel]'),
    clearfilters: root.querySelector('[data-bb-clearfilters]'),
    panelBrand: root.querySelector('[data-bb-panel-brand]'),
    panelTitle: root.querySelector('[data-bb-panel-title]'),
    mobilebar: root.querySelector('[data-bb-mobilebar]')
  };

  var money = function (n) { return '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var esc = function (s) { var d = document.createElement('span'); d.textContent = String(s == null ? '' : s); return d.innerHTML.replace(/"/g, '&quot;'); };
  var iconFor = function (key) { var t = root.querySelector('[data-bb-icon="' + key + '"]'); return t ? t.innerHTML : ''; };
  var catBy = function (key) { return CATS.filter(function (c) { return c.key === key; })[0]; };
  var brandFilter = function () { return JSON.stringify({ productVendor: S.brand }); };

  /* ---------- totals + discounts ---------- */
  function pickList() { return CATS.map(function (c) { return c.key === 'extras' ? null : S.picks[c.key]; }).filter(Boolean).concat(S.xtra); }
  function discountPct(forQuote) {
    if (!S.brandEl) return 0;
    var n = pickList().length;
    var a = forQuote ? 'data-discount-quote' : 'data-discount-amount';
    var b = forQuote ? 'data-discount-quote-extra' : 'data-discount-extra';
    var v = parseFloat(S.brandEl.getAttribute(n >= 4 ? b : a)) || 0;
    return v;
  }
  function totals() {
    var list = pickList();
    var itemsSum = list.reduce(function (a, p) { return a + p.price; }, 0);
    var compareSum = list.reduce(function (a, p) { return a + (p.compare || p.price); }, 0);
    var pct = discountPct(false);
    var discounted = itemsSum * (100 - pct) / 100;
    var warrPrice = (S.warr === 3 || S.warr === 5) && S.warrPick ? S.warrPick.price : 0;
    var total = discounted + warrPrice;
    var save = compareSum - discounted;
    var savePct = compareSum ? Math.round(save / compareSum * 100) : 0;
    return { count: list.length, itemsSum: itemsSum, discounted: discounted, compareSum: compareSum, pct: pct, warrPrice: warrPrice, total: total, save: save, savePct: savePct };
  }

  /* ---------- warranty bands (same walk as the legacy builder) ---------- */
  function lgap(year, count, bundleTotal) {
    var raw = (window.HOD_PP_RAW || []).filter(function (e) { return e.f === 'LGAP' && e.y === year && e.n === (count < 2 ? 2 : count > 6 ? 6 : count); });
    if (!raw.length) return null;
    raw.sort(function (a, b) { return a.total - b.total; });
    /* band totals are CENTS (250000 = "under $2,500"); bundleTotal arrives in
       dollars — compare in cents or every bundle lands in the first band */
    var cents = Math.round(bundleTotal * 100);
    var temp = raw[raw.length - 1]; /* above every band -> largest */
    for (var i = 0; i < raw.length; i++) {
      if (cents < raw[i].total) { temp = raw[i]; break; }
    }
    return temp ? { id: temp.id, price: parseFloat(temp.price) / 100 } : null;
  }

  /* ---------- proxy ---------- */
  var cache = {};
  function panelFilters(cat) {
    var out = [];
    if (cat !== 'extras') out.push(brandFilter()); /* extras are brand-agnostic (Stas 8/22) */
    out.push(JSON.stringify({ available: true }));
    if (cat === 'dish') out.push(JSON.stringify({ productMetafield: { namespace: 'custom', key: 'size', value: '24"' } })); /* 24" only (Stas 8/22) */
    var sel = S.chips[cat] || {};
    Object.keys(sel).forEach(function (k) { if (sel[k]) out.push(sel[k]); });
    return out;
  }
  function fetchCat(cat, cursor) {
    var c = catBy(cat);
    var body = { filters: panelFilters(cat), collection: c.coll };
    if (cursor) body.afterCursor = cursor;
    var key = JSON.stringify(body);
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetch(PROXY, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) { cache[key] = res; return res; });
  }
  /* ---------- product mapping ---------- */
  function mapProduct(p) {
    var v = (p.variants && p.variants.nodes || []).filter(function (n) { return n.availableForSale; })[0] || (p.variants && p.variants.nodes || [])[0];
    if (!v) return null;
    var price = parseFloat(v.price && v.price.amount || 0);
    var compare = parseFloat(v.compareAtPrice && v.compareAtPrice.amount || 0) || price;
    var stock = window.hodResolveStock ? window.hodResolveStock(p.vendor, v) : ['', '', 'in'];
    return {
      pid: p.id, vid: v.id.replace('gid://shopify/ProductVariant/', ''),
      handle: p.handle, title: p.title, name: p.title.replace(/ \([^)]*\)$/, ''),
      sku: v.sku || '', img: p.featuredImage ? p.featuredImage.url : '',
      vendor: p.vendor, price: price, compare: compare, stockState: stock[2] || 'in',
      savePct: compare > price ? Math.round((1 - price / compare) * 100) : 0,
      stockLabel: stock[0], stockText: stock[1]
    };
  }

  /* ---------- stock + delivery block (B.70, Stas 9/28): the summary card shows inventory and ETA the way the
     mini split builder does — mirrors hod-ms-builder.js renderStock/etaHtml with the hodbb__ prefix so the copied
     CSS applies. Backordered / out-of-stock items get their own row + restock estimate; low-stock items are
     named; everything on hand shares one delivery line. ---------- */
  var ETA_ICON = '<svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" fill="none" stroke="#1F4463" stroke-width="1.8"/><line x1="3" y1="10" x2="21" y2="10" stroke="#1F4463" stroke-width="1.8"/><line x1="8" y1="2.5" x2="8" y2="7" stroke="#1F4463" stroke-width="1.8"/><line x1="16" y1="2.5" x2="16" y2="7" stroke="#1F4463" stroke-width="1.8"/><rect x="13" y="13" width="4.5" height="4.5" rx="1" fill="#F49B33"/></svg>';
  function etaHtml(text) { /* "Estimated delivery: Sep 27th-Oct 6th" → prefix + bold value, as on the PDP */
    if (!text) return '';
    var i = text.indexOf(': ');
    var inner = i > -1 ? esc(text.slice(0, i + 2)) + '<b>' + esc(text.slice(i + 2)) + '</b>' : esc(text);
    return '<div class="hodbb__stk-eta">' + ETA_ICON + '<span>' + inner + '</span></div>';
  }
  function renderStock() {
    var host = root.querySelector('[data-bb-stock]');
    if (!host) return;
    var comps = pickList().map(function (p) {
      var label = String(p.stockLabel || '').split('|')[0].trim();
      return { name: p.name || p.title || '', state: p.stockState || 'in', label: label, text: p.stockText || '' };
    });
    if (!comps.length) { host.innerHTML = ''; host.hidden = true; return; }
    var rowHtml = function (state, label, name) {
      return '<div class="hodbb__stk-row"><span class="hodbb__stk-dot hodbb__stk-dot--' + esc(state) + '"></span>' +
        '<span class="hodbb__stk-label hodbb__stk-label--' + esc(state) + '">' + esc(label) + '</span>' +
        (name ? '<span class="hodbb__stk-name">&mdash; ' + esc(name) + '</span>' : '') + '</div>';
    };
    var bad = comps.filter(function (c) { return c.state !== 'in' && c.state !== 'low'; });
    var low = comps.filter(function (c) { return c.state === 'low'; });
    var ok = comps.filter(function (c) { return c.state === 'in'; });
    /* in-stock items share the first item's delivery window unless their brand says otherwise —
       those get their own In Stock row with their own dates */
    var lead = ok.length ? ok[0].text : '';
    var others = ok.filter(function (c) { return c.text !== lead; });
    var html = '';
    bad.forEach(function (c) { html += rowHtml(c.state, c.label || (c.state === 'oos' ? 'Out of Stock' : 'Backorder'), c.name) + etaHtml(c.text); });
    /* a low-stock item is named but gets no delivery line of its own — the single estimate below covers it */
    low.forEach(function (c) { html += rowHtml('low', c.label || 'Low Stock', c.name); });
    others.forEach(function (c) { html += rowHtml('in', 'In Stock', c.name) + etaHtml(c.text); });
    if (ok.length) html += rowHtml('in', 'In Stock', (bad.length || low.length || others.length) ? 'the rest of your bundle' : '');
    var pool = ok.length ? ok : low; /* one delivery line for everything on hand (in stock + low stock) */
    if (pool.length) html += etaHtml(pool[0].text);
    host.innerHTML = html;
    host.hidden = false;
  }

  /* ---------- render: steps + rows + canvas + summary ---------- */
  function circleState(el, done, current) {
    el.classList.toggle('is-done', !!done);
    el.classList.toggle('is-current', !done && !!current);
    el.classList.toggle('is-future', !done && !current);
  }
  function render() {
    var t = totals();
    renderStock();
    /* K r2: tell screen readers when the bundle composition changes */
    if (window.hodAnnounce) {
      if (render._n !== undefined && render._n !== t.count) window.hodAnnounce(t.count + (t.count === 1 ? ' appliance' : ' appliances') + ' in your bundle');
      render._n = t.count;
    }
    var hasBrand = !!S.brand;
    var hasItems = t.count > 0;
    var warrDone = S.warr !== null;

    /* stepper */
    circleState(root.querySelector('[data-bb-circle="1"]'), hasBrand, !hasBrand);
    circleState(root.querySelector('[data-bb-circle="2"]'), hasItems, hasBrand && !hasItems);
    circleState(root.querySelector('[data-bb-circle="3"]'), warrDone, hasBrand && hasItems && !warrDone);
    root.querySelector('[data-bb-step="2"]').classList.toggle('is-locked', !hasBrand);
    root.querySelector('[data-bb-step="3"]').classList.toggle('is-locked', !hasBrand || !hasItems);

    /* brand tiles + pill */
    root.querySelectorAll('[data-bb-brand]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-bb-brand') === S.brand);
    });
    els.brandpill.hidden = !hasBrand;
    els.brandname.textContent = S.brand || '';
    /* B.76 r2: the brand step folds to a done row once a brand is picked (Change re-opens the tiles) */
    var step1 = root.querySelector('[data-bb-step="1"]'), bdone = root.querySelector('[data-bb-branddone]');
    var brandFolded = hasBrand && !S.brandOpen;
    if (step1) step1.classList.toggle('is-collapsed', brandFolded);
    if (bdone) {
      bdone.hidden = !brandFolded;
      var bdn = bdone.querySelector('[data-bb-branddone-name]');
      if (bdn) bdn.textContent = S.brand || '';
      var bcb = bdone.querySelector('[data-bb-brand-change]');
      if (bcb) bcb.setAttribute('aria-label', 'Change brand, currently ' + (S.brand || ''));
    }

    /* canvas */
    render._lastVid = render._lastVid || {};
    SLOT_KEYS.forEach(function (k) {
      var slot = root.querySelector('[data-bb-slot="' + k + '"]');
      var p = S.picks[k];
      var vid = p ? p.vid : null;
      if (vid && vid !== render._lastVid[k]) { /* a new model landed in this slot: replay the pop once */
        slot.classList.remove('is-dropped'); void slot.offsetWidth; slot.classList.add('is-dropped');
        clearTimeout(slot._dropT);
        slot._dropT = setTimeout(function () { slot.classList.remove('is-dropped'); }, 700);
      }
      render._lastVid[k] = vid;
      slot.classList.toggle('is-filled', !!p);
      slot.classList.toggle('is-active', S.view === k);
      slot.classList.toggle('is-locked', !hasBrand);
      var img = slot.querySelector('[data-bb-slot-img]');
      img.style.backgroundImage = p ? 'url("' + p.img + '")' : '';
    });
    var filled = SLOT_KEYS.filter(function (k) { return S.picks[k]; }).length;
    els.slotcount.textContent = t.count ? t.count + (t.count === 1 ? ' appliance' : ' appliances') : '';
    els.canvasprice.innerHTML = hasItems
      ? '<s>' + money(t.compareSum + t.warrPrice) + '</s><b>' + money(t.total) + '</b>' + (t.savePct > 0 ? '<span class="hodbb__savebadge">SAVE ' + t.savePct + '%</span>' : '')
      : '<span class="hodbb__canvas-empty">Add appliances to see your bundle price</span>';

    /* category rows */
    els.addedcount.textContent = t.count + ' added';
    var reviews = root.querySelectorAll('[data-bb-review]'); /* sheet head + panel head: close the panel and land on the summary */
    for (var ri = 0; ri < reviews.length; ri++) reviews[ri].hidden = !hasItems;
    var ships = root.querySelectorAll('[data-bb-ship]');
    for (var shi = 0; shi < ships.length; shi++) {
      var shb = ships[shi].getAttribute('data-bb-ship') || '';
      ships[shi].hidden = hasBrand ? shb !== S.brand : shb !== '';
    }
    var attention = hasBrand && t.count === 0;
    var filledRow = function (c, p, removeAttr) {
      return '<div class="hodbb__row hodbb__row--filled" data-bb-rowcat="' + c.key + '">' +
        '<span class="hodbb__row-thumb" aria-hidden="true" style="background-image:url(\'' + p.img + '\')"></span>' +
        '<span class="hodbb__row-info">' +
          '<span class="hodbb__row-kind">' + esc(c.kind) + '</span>' +
          '<span class="hodbb__row-name">' + esc(p.name) + '</span>' +
          '<span class="hodbb__row-sku">SKU: <b>' + esc(p.sku) + '</b></span>' +
          '<span class="hodbb__row-pricerow"><b class="hodbb__price">' + money(p.price) + '</b>' + (p.compare > p.price ? '<s>' + money(p.compare) + '</s>' : '') +
            (p.stockLabel ? '<span class="hodbb__stockline hodbb__stockline--' + esc(p.stockState || 'in') + '"><i></i><b>' + esc(p.stockLabel.split('|')[0].trim()) + '</b></span>' : '') + '</span>' +
        '</span>' +
        '<span class="hodbb__row-side"><button type="button" class="hodbb__row-x" ' + removeAttr + ' aria-label="Remove">&#10005;</button><a class="hodbb__link" data-bb-open="' + c.key + '" role="button" tabindex="0">Change</a></span>' +
      '</div>';
    };
    els.rows.innerHTML = CATS.map(function (c) {
      if (c.key === 'extras') {
        var stateClsX = !hasBrand ? 'is-locked' : attention ? 'is-attention' : '';
        return S.xtra.map(function (xp, xi) { return filledRow(c, xp, 'data-bb-remove-x="' + xi + '"'); }).join('') +
          '<button type="button" class="hodbb__row hodbb__row--empty ' + stateClsX + '" data-bb-open="extras">' +
            '<span class="hodbb__row-icon">' + iconFor('extras') + '</span>' +
            '<span class="hodbb__row-label">' + (S.xtra.length ? 'Add another extra' : esc(c.label)) + '</span>' +
            '<svg width="7" height="12" viewBox="0 0 7 12"><path d="M1 1l5 5-5 5" fill="none" stroke="#98A2AE" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>';
      }
      var p = S.picks[c.key];
      if (p) { return filledRow(c, p, 'data-bb-remove="' + c.key + '"'); }
      var stateCls = !hasBrand ? 'is-locked' : attention ? 'is-attention' : '';
      return '<button type="button" class="hodbb__row hodbb__row--empty ' + stateCls + '" data-bb-open="' + c.key + '">' +
        '<span class="hodbb__row-icon">' + iconFor(c.key) + '</span>' +
        '<span class="hodbb__row-label">' + esc(c.label) + '</span>' +
        '<svg width="7" height="12" viewBox="0 0 7 12"><path d="M1 1l5 5-5 5" fill="none" stroke="#98A2AE" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';
    }).join('');

    /* warranty chips */
    var count = t.count;
    var w3 = hasItems ? lgap(3, count, t.discounted) : null;
    var w5 = hasItems ? lgap(5, count, t.discounted) : null;
    if (S.warr === 3) S.warrPick = w3 ? { id: w3.id, price: w3.price, year: 3 } : null;
    else if (S.warr === 5) S.warrPick = w5 ? { id: w5.id, price: w5.price, year: 5 } : null;
    else S.warrPick = null;
    /* pass 4 (Stas 9/28): the protection step folds once a plan (or "no plan") is chosen, like the brand step */
    var step3 = root.querySelector('[data-bb-step="3"]'), wdone = root.querySelector('[data-bb-warrdone]');
    var warrFolded = S.warr !== null && !S.warrOpen;
    if (step3) step3.classList.toggle('is-collapsed', warrFolded);
    if (wdone) {
      wdone.hidden = !warrFolded;
      var wname = S.warr === null ? '' : (S.warr === 0 ? 'No plan' : (S.warrPick ? S.warrPick.year + '-Year CPS \u00b7 ' + money(S.warrPick.price) : S.warr + '-Year CPS'));
      var wn = wdone.querySelector('[data-bb-warrdone-name]'); if (wn) wn.textContent = wname;
      var wc = wdone.querySelector('[data-bb-warr-change]'); if (wc) wc.setAttribute('aria-label', 'Change protection plan, currently ' + wname);
    }
    var chips = [{ v: 0, label: 'No Plan' }];
    if (w3) chips.push({ v: 3, label: '3-Year &middot; ' + money(w3.price) });
    if (w5) chips.push({ v: 5, label: '5-Year &middot; ' + money(w5.price) });
    els.warr.innerHTML = chips.map(function (ch) {
      return '<button type="button" class="hodbb__chip' + (S.warr === ch.v ? ' is-on' : '') + '" data-bb-warrpick="' + ch.v + '">' + ch.label + '</button>';
    }).join('');

    /* recompute total with resolved warranty price */
    t = totals();

    /* summary */
    root.querySelector('[data-bb-itemcount]').textContent = t.count;
    root.querySelector('[data-bb-itemstotal]').textContent = money(t.itemsSum);
    var discRow = root.querySelector('[data-bb-discrow]');
    discRow.hidden = !(t.pct > 0 && t.count > 0);
    if (!discRow.hidden) {
      root.querySelector('[data-bb-discpct]').textContent = t.pct;
      root.querySelector('[data-bb-discval]').textContent = '\u2212' + money(t.itemsSum - t.discounted);
    }
    var wr = root.querySelector('[data-bb-warrrow]');
    wr.hidden = !(S.warr === 3 || S.warr === 5) || !S.warrPick;
    if (!wr.hidden) {
      root.querySelector('[data-bb-warrlabel]').textContent = S.warrPick.year + '-Year CPS Protection';
      root.querySelector('[data-bb-warrprice]').textContent = money(S.warrPick.price);
    }
    root.querySelector('[data-bb-total]').textContent = money(t.total);
    var affP = root.querySelector('[data-bb-affirm-p]');
    var affFb = root.querySelector('[data-bb-affirm-fallback]');
    if (affP && window.affirm && window.affirm.ui) {
      affFb.hidden = true;
      var affCents = String(Math.round(t.total * 100));
      if (affP.getAttribute('data-amount') !== affCents) {
        affP.setAttribute('data-amount', affCents);
        try { window.affirm.ui.refresh(); } catch (e) { /* non-critical */ }
      }
    } else if (affFb) {
      affFb.hidden = false;
      root.querySelector('[data-bb-monthly]').textContent = money(t.total / 28.85) + '/mo';
    }
    var cta = root.querySelector('[data-bb-addcart]');
    cta.disabled = !hasItems;
    cta.classList.toggle('is-added', S.added);
    root.querySelector('[data-bb-cartlabel]').textContent = S.added ? 'Added to Cart' : 'Add Bundle to Cart';

    /* mobile bar */
    els.mobilebar.hidden = !hasItems;
    root.querySelector('[data-bb-mob-total]').textContent = money(t.total);
    root.querySelector('[data-bb-mob-list]').textContent = t.savePct > 0 ? money(t.compareSum + t.warrPrice) : '';

    /* view swap */
    els.overview.hidden = S.view !== null;
    els.panel.hidden = S.view === null;
    syncBrowse();
  }

  /* ---------- panel ---------- */
  function openPanel(cat) {
    if (!S.brand) return;
    S.view = cat;
    render();
    var c = catBy(cat);
    els.panelBrand.textContent = S.brand.toUpperCase();
    els.panelTitle.textContent = 'Add ' + (c.short || c.label);
    els.prods.innerHTML = '<div class="hodbb__loading">Loading models&hellip;</div>';
    loadPanel(cat);
    /* 9/29 Stas trial: no page scroll on open — the sheet is an absolute, self-scrolling box over the kitchen card (main's CSS) */
      syncBrowse(); /* the title/brand above are set after render() */
    focusEl(els.panel.querySelector('[data-bb-back]')); /* keyboard: the rail's back circle is the way out on every layout (the sheet has no Back button since 9/29) */
  }
  function loadPanel(cat) {
    var seq = ++S.fetchSeq;
    fetchCat(cat).then(function (res) {
      if (seq !== S.fetchSeq || S.view !== cat) return;
      renderFilters(cat, res.filters || []);
      if (S.focusFacet) { /* 9/29 (Stas): after a chip pick the row stays open — keep the chosen chip in sight (one-line scrollers) and focused */
        var fsel = '[data-bb-chip][data-facet="' + cssEsc(S.focusFacet) + '"]';
        var fchip = els.filters.querySelector(fsel + '.is-on') || (S.focusInput ? els.filters.querySelector(fsel + '[data-input="' + cssEsc(S.focusInput) + '"]') : null);
        if (fchip) {
          if (fchip.scrollIntoView) fchip.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          focusEl(fchip);
        }
        S.focusFacet = null; S.focusInput = null;
      }
      if (S.focusClear) { /* after Clear filters (the link hides itself): the first chip of the first row is where the shopper goes next; else the back circle */
        S.focusClear = false;
        focusEl(els.filters.querySelector('[data-bb-frow] [data-bb-chip]') || els.panel.querySelector('[data-bb-back]'));
      }
      var prods = (Array.isArray(res.products) ? res.products : []).map(mapProduct).filter(Boolean);
      var selCount = Object.keys(S.chips[cat] || {}).filter(function (k) { return (S.chips[cat] || {})[k]; }).length;
      els.matchlabel.textContent = '';
      els.clearfilters.hidden = !selCount;
      renderProds(cat, prods, res.pagination);
    }).catch(function () {
      if (S.view === cat) els.prods.innerHTML = '<div class="hodbb__loading">Something went wrong loading models. <a class="hodbb__link" data-bb-retry role="button" tabindex="0">Retry</a></div>';
    });
  }
  function renderFilters(cat, facets) {
    var sel = S.chips[cat] || {};
    /* cache each facet's values while it has no selection, and render the
       cached list once one IS selected — otherwise picking e.g. Wall makes
       the other mount types vanish (the filtered response only returns
       matching values) */
    S.facetVals[cat] = S.facetVals[cat] || {};
    facets.forEach(function (f) { if (!sel[f.label]) S.facetVals[cat][f.label] = f.values || []; });
    facets = facets.map(function (f) {
      return sel[f.label] && S.facetVals[cat][f.label] ? { label: f.label, values: S.facetVals[cat][f.label] } : f;
    });
    /* 9/29 (Stas): a chosen group no longer folds to a done row — every row stays open, the chosen chip keeps
       .is-on (CSS: navy ring + check, the row's other chips go quiet) and there is no Change button */
    els.filters._facets = facets;
    var shown = facets.filter(function (f) {
      return facetIdx(cat, f.label) >= 0 && (f.values || []).length > 0;
    }).sort(function (a, b) { return facetIdx(cat, a.label) - facetIdx(cat, b.label); });
    var swatchHtml = function (v) {
      var swImg = v.swatch && v.swatch.image && v.swatch.image.image && v.swatch.image.image.url;
      return swImg ? '<span class="hodbb__chip-swatch" style="background-image:url(\'' + esc(swImg) + '\')"></span>'
        : (v.swatch && v.swatch.color ? '<span class="hodbb__chip-swatch" style="background:' + esc(v.swatch.color) + '"></span>' : '');
    };
    els.filters.innerHTML = shown.map(function (f) {
      var help = null;
      HELP_BY_FACET.forEach(function (h) { if (!help && h[0].test(f.label)) help = h[1]; });
      var rule = facetRule(cat, f.label);
      var fvals = (f.values || []).slice();
      if (rule.allow) fvals.sort(function (a, b) {
        return rule.allow.indexOf((a.label || '').trim().toLowerCase()) - rule.allow.indexOf((b.label || '').trim().toLowerCase());
      });
      var chips = fvals.map(function (v) {
        if (!v.count) return '';
        var vl = (v.label || '').trim().toLowerCase();
        if (rule.allow && rule.allow.indexOf(vl) < 0) return '';
        if (rule.block && rule.block.indexOf(vl) >= 0) return '';
        var on = sel[f.label] === v.input;
        return '<button type="button" class="hodbb__chip' + (on ? ' is-on' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" data-bb-chip data-facet="' + esc(f.label) + '" data-input="' + esc(v.input) + '">' + swatchHtml(v) + esc(v.label) + '</button>';
      }).join('');
      if (!chips) return '';
      return '<div class="hodbb__filterrow" data-bb-frow data-facet="' + esc(f.label) + '"><span class="hodbb__filterrow-head"><b>' + esc(rule.alias || f.label) + '</b>' +
        (help ? '<button type="button" class="hodbb__helpdot" data-bb-help="' + help + '" aria-label="Help">?</button>' : '') +
        '</span><span class="hodbb__chips">' + chips + '</span></div>';
    }).join('');
  }
  function renderProds(cat, prods, pagination) {
    if (!prods.length) {
      els.prods.innerHTML = '<div class="hodbb__nomatch">No ' + esc(S.brand) + ' models match these filters.<br><a class="hodbb__link" data-bb-clearfilters2 role="button" tabindex="0">Clear filters</a> or try another brand.</div>';
      return;
    }
    var html = prods.map(function (p, i) { return cardHtml(cat, p, i); }).join('');
    html += loadMoreHtml(pagination);
    els.prods.innerHTML = html;
    els.prods._prods = prods;
  }
  function loadMoreHtml(pagination) {
    return (pagination && pagination.hasNextPage)
      ? '<button type="button" class="hodbb__loadmore" data-bb-loadmore data-cursor="' + esc(pagination.endCursor) + '">Load more models</button>' : '';
  }
  function cardHtml(cat, p, i) {
    var pick = S.picks[cat];
    var xvids = cat === 'extras' ? S.xtra.map(function (x) { return x.vid; }) : null;
    var inB = xvids ? xvids.indexOf(p.vid) > -1 : (pick && pick.vid === p.vid);
    return '<div class="hodbb__pcard bundle-builder--choose-item' + (i === 0 ? ' is-rec' : '') + (inB ? ' is-inbundle' : '') + '" data-bb-card data-bb-slotlabel="' + esc((catBy(cat).short || catBy(cat).label)) + '" data-pid="' + esc(p.pid) + '" data-title="' + esc(p.title) + '" data-variant="" data-handle="' + esc(p.handle) + '" data-product-url="/products/' + esc(p.handle) + '" data-stock="' + esc(p.stockLabel) + '" data-delivery="' + esc(p.stockText) + '">' +
        (i === 0 ? '<span class="hodbb__rectag">RECOMMENDED MODEL</span>' : '') +
        '<span class="hodbb__pcard-img" aria-hidden="true" style="background-image:url(\'' + p.img + '\')"></span>' +
        '<span class="hodbb__pcard-info">' +
          '<span class="hodbb__pcard-name">' + esc(p.name) + '</span>' +
          '<span class="hodbb__row-sku">SKU: <b>' + esc(p.sku) + '</b></span>' +
          '<span class="hodbb__pcard-pricerow"><b class="hodbb__price">' + money(p.price) + '</b>' + (p.compare > p.price ? '<s>' + money(p.compare) + '</s><span class="hodbb__savebadge">SAVE ' + p.savePct + '%</span>' : '') + '</span>' +
          (p.stockLabel ? '<span class="hodbb__stockline hodbb__stockline--' + esc(p.stockState || 'in') + '"><i></i><b>' + esc(p.stockLabel.split('|')[0].trim()) + '</b>' + (p.stockText ? '<span class="hodbb__stocktext">&middot; ' + esc(p.stockText) + '</span>' : '') + '</span>' : '') +
          '<span class="hodbb__pcard-btns">' +
            '<button type="button" class="hodbb__pcard-add bundle-builder--choose-add' + (inB ? ' is-in' : '') + '" data-bb-add="' + i + '">' + (inB ? '&#10003; In Bundle &mdash; tap to remove' : '+ Add to Bundle') + '</button>' +
            '<button type="button" class="hodbb__pcard-view bundle-builder--choose-view" data-product-url="/products/' + esc(p.handle) + '" data-stock="' + esc(p.stockLabel) + '" data-delivery="' + esc(p.stockText) + '">View Details</button>' +
          '</span>' +
        '</span>' +
      '</div>';
  }
  function unmarkCard(btn) { /* the card stays where it is; only its state flips */
    btn.classList.remove('is-in');
    btn.innerHTML = '+ Add to Bundle';
    var card = btn.closest('[data-bb-card]');
    if (card) card.classList.remove('is-inbundle');
  }
  function loadMore(cursor, btn) {
    var cat = S.view;
    btn.textContent = 'Loading…';
    fetchCat(cat, cursor).then(function (res) {
      if (S.view !== cat) return;
      var have = els.prods._prods || [];
      var more = (Array.isArray(res.products) ? res.products : []).map(mapProduct).filter(Boolean);
      /* append only the new cards (the rise animation keys on fresh nodes; the ones on screen stay put) */
      var html = more.map(function (p, i) { return cardHtml(cat, p, have.length + i); }).join('') + loadMoreHtml(res.pagination);
      var old = els.prods.querySelector('[data-bb-loadmore]');
      if (old) old.parentNode.removeChild(old);
      els.prods.insertAdjacentHTML('beforeend', html);
      els.prods._prods = have.concat(more);
    }).catch(function () { btn.textContent = 'Load more models'; });
  }

  /* ---------- cache warm-up on brand pick ---------- */
  function prefetchCounts() {
    CATS.forEach(function (c) { fetchCat(c.key).catch(function () {}); });
  }

  /* ---------- help modals ---------- */
  var HELP = {
    fuel: { title: 'Fuel Type', html: '<div class="hodbb__modal-sub">What each option means for your cooktop, oven &amp; hookup</div><div class="hodbb__fuelgrid"><div class="hodbb__fuelcard"><b>Gas</b><span>Gas Cooktop &amp; Gas Oven</span><em class="is-ok">Standard gas hookup</em></div><div class="hodbb__fuelcard"><b>Dual Fuel</b><span>Gas Cooktop &amp; Electric Oven</span><em>Requires a 240v electric outlet</em></div><div class="hodbb__fuelcard"><b>Electric</b><span>Electric Cooktop &amp; Electric Oven</span><em>Requires a 240v electric outlet</em></div><div class="hodbb__fuelcard"><b>Induction</b><span>Induction Cooktop &amp; Electric Oven</span><em>Requires a 240v electric outlet</em></div></div><div class="hodbb__fuelnote"><b>Induction cookware:</b> Induction cooktops require cookware made from magnetic materials for proper heating, such as cast iron (including enameled) and most types of stainless steel. Other types like aluminum, glass, and copper, require a magnetic bottom layer.</div><button type="button" class="hodbb__fuelclose" data-bb-help-close>Close</button>' },
    micro: { title: 'Microwave Type', html: '<h4>Microwave Drawer</h4><ul><li>Installs at waist level in wall cabinets or islands</li><li>Slides out like a cabinet drawer</li></ul><h4>Built-In Microwave Oven</h4><ul><li>Mounts at waist or eye level, flush with cabinets</li></ul><h4>Over-the-Range</h4><ul><li>Installs above a 30" range</li><li>Built-in vent doubles as your range hood</li></ul>' },
    cfm: { title: 'Range Hood Power (CFM)', html: '<h4>What is CFM?</h4><ul><li>Cubic Feet per Minute &mdash; how much air the hood moves</li><li>Higher CFM = more powerful motor</li></ul><h4>What&rsquo;s right for me?</h4><ul><li>400 CFM handles most kitchens</li><li>High-BTU gas ranges (48"+) benefit from 1,000+ CFM</li></ul>' },
    warranty: { title: 'CPS Extended Protection', html: '<h4>One plan, whole bundle</h4><ul><li>Covers every appliance in this bundle</li><li>Parts and labor with in-home service</li><li>Power-surge protection included</li><li>No deductibles &mdash; starts after the manufacturer warranty</li></ul>' }
  };
  function openHelp(topic) {
    var m = root.querySelector('[data-bb-modal="help"]');
    var data = HELP[topic];
    if (topic === 'series') {
      var tpl = root.querySelector('[data-bb-serieshelp="' + S.brand + '"]');
      data = tpl ? { title: tpl.getAttribute('data-title'), html: tpl.innerHTML } : HELP.warranty;
    }
    if (!data) return;
    m.querySelector('[data-bb-help-title]').textContent = data.title;
    m.querySelector('[data-bb-help-body]').innerHTML = data.html;
    m.hidden = false;
  }

  /* ---------- cart + quote ---------- */
  function buildItems(forQuote) {
    var bundleID = Date.now();
    var pct = discountPct(forQuote);
    var merge = !forQuote && MERGE && !!PARENT_VID;
    var fold = merge ? foldStock(pickList()) : null;
    var items = pickList().map(function (p) {
      var props = {}; props[forQuote ? 'Quote Bundle ID' : 'Bundle ID'] = String(bundleID);
      if (pct > 0 && forQuote) props['Bundle Discount'] = pct + '%'; /* quotes only (quote.php reads it); in the cart the tier comes from the Bundle Discount function */
      /* each build is its own group (_bundle_id = the build id) merged under the parent variant
         (_bundle_parent, app version 7+): two builds in one cart stay two lines (review 9/24) */
      if (merge) Object.assign(props, { '_bundle_id': String(bundleID), '_bundle_parent': PARENT_VID, '_bundle_product': PARENT_TITLE, '_bundle_discount': '0.0%', '_bundle_stock': fold.label, '_bundle_eta': fold.text });
      if (p.stockLabel) props['Stock'] = p.stockLabel;
      if (p.stockText) props['ETA'] = p.stockText.replace(/^Estimated (delivery|restock):\s*/i, '');
      return { id: parseInt(p.vid, 10), quantity: 1, properties: props };
    });
    if ((S.warr === 3 || S.warr === 5) && S.warrPick) {
      items.push({ id: parseInt(S.warrPick.id, 10), quantity: 1 });
    }
    return items;
  }
  function addToCart(btnLabelEl) {
    var t = totals();
    if (!t.count || S.added) return;
    var items = buildItems(false);
    var cta = root.querySelector('[data-bb-addcart]');
    cta.disabled = true;
    root.querySelector('[data-bb-cartlabel]').textContent = 'Adding…';
    /* 10/8: the bundle tier is applied by the Shopify Function automatic discount ("Bundle Discount");
       the one-use code minter is retired, so the cart add goes straight to checkout */
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    }).catch(function () {
      cta.disabled = false;
      root.querySelector('[data-bb-cartlabel]').textContent = 'Add Bundle to Cart';
      alert('Something went wrong adding your bundle to the cart. Please try again.');
    });
  }
  function sendQuote() {
    var emailEl = root.querySelector('[data-bb-quote-email]');
    var email = (emailEl.value || '').trim();
    if (!/@/.test(email)) return;
    var send = root.querySelector('[data-bb-quote-send]');
    send.disabled = true; send.textContent = 'Sending…';
    fetch(CUSTOM_APP + '/quote.php', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: buildItems(true), email: email })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || res.success === false) throw new Error('quote failed');
      root.querySelector('[data-bb-quote-form]').hidden = true;
      var sent = root.querySelector('[data-bb-quote-sent]');
      sent.hidden = false;
      root.querySelector('[data-bb-quote-sentto]').textContent = email;
      var t = totals();
      var qpct = discountPct(true);
      root.querySelector('[data-bb-quote-total2]').textContent = money(t.itemsSum * (100 - qpct) / 100 + t.warrPrice);
    }).catch(function () {
      send.disabled = false; send.textContent = 'Send My Quote →';
      alert('Something went wrong sending your quote. Please try again.');
    });
  }
  function openQuote() {
    var t = totals();
    if (!t.count) return;
    var m = root.querySelector('[data-bb-modal="quote"]');
    root.querySelector('[data-bb-quote-form]').hidden = false;
    root.querySelector('[data-bb-quote-sent]').hidden = true;
    var qpct = discountPct(true);
    var qitems = t.itemsSum * (100 - qpct) / 100;
    var qdisc = t.discounted - qitems; /* extra savings vs the cart price */
    var qtotal = qitems + t.warrPrice;
    root.querySelector('[data-bb-quote-summary]').textContent = t.count + '-piece ' + S.brand + ' appliance bundle' + (S.warrPick ? ' + CPS protection plan' : '');
    root.querySelector('[data-bb-quote-bundletotal]').textContent = money(t.total);
    root.querySelector('[data-bb-quote-btrow]').hidden = !(qdisc > 0.005);
    var qdiscRow = root.querySelector('[data-bb-quote-discrow]');
    qdiscRow.hidden = !(qdisc > 0.005);
    if (qdisc > 0.005) root.querySelector('[data-bb-quote-disc]').textContent = '\u2212' + money(qdisc);
    root.querySelector('[data-bb-quote-total]').textContent = money(qtotal);
    m.hidden = false;
    setTimeout(function () { root.querySelector('[data-bb-quote-email]').focus(); }, 60);
  }

  /* ---------- mobile canvas placement (Stas 8/23) ----------
     on phones the kitchen scene sits between the appliance selector
     (step 2) and the warranty card (step 3); on desktop it returns to
     the left column. DOM move because CSS order can't interleave the
     two grid columns. */
  var bbMq = window.matchMedia('(max-width: 980px)');
  function placeCanvas() {
    var canvas = root.querySelector('.hodbb__canvascol');
    var grid = root.querySelector('.hodbb__grid');
    var step2 = root.querySelector('[data-bb-step="2"]');
    if (!canvas || !grid || !step2) return;
    if (bbMq.matches) {
      if (canvas.previousElementSibling !== step2) step2.after(canvas);
    } else if (canvas.parentElement !== grid) {
      grid.insertBefore(canvas, grid.firstElementChild);
    }
  }
  placeCanvas();
  if (bbMq.addEventListener) bbMq.addEventListener('change', placeCanvas);
  window.addEventListener('resize', placeCanvas);

  /* ---------- B.76 browse mode (Stas 9/28): on the Wide layout at desktop widths an open category panel
     moves its match line + product list out of the rail into the left column's browse card
     ([data-bb-browse]) — a 2-column grid under the shrunken canvas strip — while the rail keeps the
     filters. The SAME nodes move (appendChild), so els.prods and the root-level click delegation keep
     working; they move back when the panel closes or the viewport drops below 1024px. ---------- */
  var browse = {
    card: root.querySelector('[data-bb-browse]'),
    host: root.querySelector('[data-bb-browse-host]'),
    title: root.querySelector('[data-bb-browse-title]'),
    brand: root.querySelector('[data-bb-browse-brand]')
  };
  function cssEsc(v) { return window.CSS && CSS.escape ? CSS.escape(String(v)) : String(v).replace(/"/g, '\\"'); }
  function isBrowseMode() { return root.classList.contains('hodbb--wide') && window.matchMedia('(min-width:1024px)').matches; }
  var closeT = null;
  function reduceMotion() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function finishClose() { /* the deferred half of a close: nodes home, card hidden (theme.css [hidden] is display:none) */
    if (els.prods.parentNode === browse.host) els.panel.appendChild(els.prods); /* 9/29: only the product list travels; the match line (Clear filters) stays in the panel head */
    if (!browse.card.hidden) browse.card.hidden = true;
    browse.card.classList.remove('is-closing');
    root.classList.remove('hodbb--browsing'); /* only now does the canvas grow back */
    setCanvasInert(false);
    S.scrollAfterClose = null; /* 9/29 Stas trial: no page scroll on close — the page length no longer changes when the sheet opens/closes (sheet = absolute box over the kitchen card, main's CSS), so the viewport stays put by itself; the deferred-scroll bookkeeping in requestCardScroll()/closePanel() stays inert */
  }
  function scrollToCard(el) { /* keep the viewport on a card (rows after an add / Back, the summary after Review) */
    if (!el) return;
    var oy = el.getBoundingClientRect().top + window.pageYOffset - 84;
    window.scrollTo({ top: oy > 0 ? oy : 0, behavior: reduceMotion() ? 'auto' : 'smooth' });
  }
  function requestCardScroll(el) {
    /* while a browse close is still sinking, the rail is position:sticky and the cards' rects are their
       pinned positions — defer the scroll to finishClose(); otherwise scroll now */
    if (!el) return;
    if (typeof browse !== 'undefined' && browse && browse.card && !browse.card.hidden && browse.card.classList.contains('is-closing')) S.scrollAfterClose = el;
    else scrollToCard(el);
  }
  function requestRowsScroll() { requestCardScroll(els.rows && els.rows.closest('.hodbb__card')); }
  /* 9/29 overlay keyboard items (main session's review round): the kitchen canvas is inert under the desktop sheet,
     focus moves into the sheet on open and back to the opening row on close, Escape closes, and below 1024px the
     rail panel (a fixed bottom sheet) carries dialog semantics while open */
  var canvasCard = root.querySelector('.hodbb__canvas-card');
  function setCanvasInert(on) {
    if (!canvasCard) return;
    if ('inert' in canvasCard) { canvasCard.inert = on; return; }
    if (on) canvasCard.setAttribute('aria-hidden', 'true'); else canvasCard.removeAttribute('aria-hidden');
    var slots = canvasCard.querySelectorAll('[data-bb-slot]');
    for (var i = 0; i < slots.length; i++) { if (on) slots[i].setAttribute('tabindex', '-1'); else slots[i].removeAttribute('tabindex'); }
  }
  function isSheetMode() { return !(window.matchMedia && window.matchMedia('(min-width:1024px)').matches); }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function syncPanelDialog() {
    if (S.view !== null && isSheetMode()) {
      var pt = els.panel.querySelector('[data-bb-panel-title]');
      if (pt && !pt.id) pt.id = 'hodbb-panel-title';
      els.panel.setAttribute('role', 'dialog'); els.panel.setAttribute('aria-modal', 'true');
      if (pt) els.panel.setAttribute('aria-labelledby', pt.id);
    } else {
      els.panel.removeAttribute('role'); els.panel.removeAttribute('aria-modal'); els.panel.removeAttribute('aria-labelledby');
    }
  }
  function closePanel(scrollEl) { /* every close path: Back, Review, Escape, a tap on the mobile sheet's backdrop */
    var cat = S.view;
    if (cat === null) return;
    S.view = null; render();
    requestCardScroll(scrollEl || (els.rows && els.rows.closest('.hodbb__card')));
    focusEl(root.querySelector('[data-bb-open="' + cssEsc(cat) + '"]')); /* back to the row that opened it; the scroll above owns the position */
  }
  function syncBrowse() {
    if (typeof browse === 'undefined' || !browse || !browse.card || !browse.host || !els.panel || !els.prods) return;
    syncPanelDialog();
    var open = S.view !== null && isBrowseMode();
    if (open) {
      clearTimeout(closeT); closeT = null;
      browse.card.classList.remove('is-closing'); /* a reopen inside the exit window cancels the deferred move */
      if (els.prods.parentNode !== browse.host) browse.host.appendChild(els.prods); /* 9/29: ONLY [data-bb-prods]; .hodbb__matchline stays in the panel head */
      var pt = els.panel.querySelector('[data-bb-panel-title]'), pb = els.panel.querySelector('[data-bb-panel-brand]');
      if (browse.title && pt) browse.title.textContent = pt.textContent;
      if (browse.brand) browse.brand.textContent = pb ? pb.textContent : (S.brand || '');
      if (browse.card.hidden) browse.card.hidden = false;
      root.classList.add('hodbb--browsing');
      setCanvasInert(true); /* nothing under the sheet is reachable by Tab or a screen reader */
    } else {
      if (browse.card.hidden && !browse.card.classList.contains('is-closing')) return; /* already closed */
      clearTimeout(closeT);
      if (isBrowseMode()) {
        /* sink 220 ms first (hodbb--browsing stays so the canvas holds still), then hide, move back, class off */
        browse.card.classList.add('is-closing'); /* CSS: .hodbb__browse.is-closing = the exit animation */
        closeT = setTimeout(finishClose, reduceMotion() ? 0 : 220);
      } else {
        finishClose(); /* viewport narrowed: no exit animation, straight home */
      }
    }
  }
  var browseResizeT = null;
  window.addEventListener('resize', function () {
    clearTimeout(browseResizeT);
    browseResizeT = setTimeout(syncBrowse, 120);
  });

  /* ---------- brand pick ---------- */
  function pickBrand(el) {
    var b = el.getAttribute('data-bb-brand');
    if (b === S.brand) { S.brandOpen = false; render(); return; } /* re-tapping the current brand folds the step again */
    if (pickList().length) {
      var m = root.querySelector('[data-bb-modal="reset"]');
      m.querySelector('[data-bb-reset-brand]').textContent = b;
      var rt = totals();
      var kinds = pickList().map(function (p) { return catBy(p.cat).short || catBy(p.cat).label; });
      var klist = kinds.length > 1 ? kinds.slice(0, -1).join(', ') + ' & ' + kinds[kinds.length - 1] : kinds.join('');
      m.querySelector('[data-bb-reset-count]').textContent = rt.count + '-piece ' + S.brand.toUpperCase() + ' bundle';
      m.querySelector('[data-bb-reset-total]').textContent = money(rt.total);
      m.querySelector('[data-bb-reset-items]').textContent = klist + ' will be removed';
      m.hidden = false;
      m._pending = el;
      return;
    }
    applyBrand(el);
  }
  function applyBrand(el) {
    S.brand = el.getAttribute('data-bb-brand');
    S.brandEl = el;
    S.brandOpen = false; S.warrOpen = false;
    S.picks = {}; S.chips = {}; S.facetVals = {}; S.xtra = []; S.warr = null; S.warrPick = null; S.view = null;
    cache = {};
    render();
    var bc = root.querySelector('[data-bb-brand-change]');
    if (bc && !bc.closest('[hidden]')) { try { bc.focus({ preventScroll: true }); } catch (e) { bc.focus(); } }
    prefetchCounts();
  }

  /* ---------- events (delegated) ---------- */
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') { /* close the open category sheet (not while a modal is up) */
      if (S.view !== null && !root.querySelector('[data-bb-modal]:not([hidden])')) { e.preventDefault(); closePanel(); }
      return;
    }
    /* a11y (K.3.3): Enter/Space operate the link-styled buttons */
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest('[data-bb-open],[data-bb-help],[data-bb-clearfilters],[data-bb-clearfilters2],[data-bb-retry],[data-bb-review]');
    if (!t || t.tagName === 'BUTTON') return;
    e.preventDefault(); t.click();
  });
  root.addEventListener('click', function (e) {
    var t = e.target;
    var hit = function (sel) { return t.closest ? t.closest(sel) : null; };

    if (t === els.panel && S.view !== null && isSheetMode()) { closePanel(); return; } /* tap outside the mobile sheet's content = Back */
    if (hit('[data-bb-brand-change]')) {
      S.brandOpen = true; render();
      var onTile = root.querySelector('[data-bb-brand].is-on');
      if (onTile) { try { onTile.focus({ preventScroll: true }); } catch (e) { onTile.focus(); } }
      return;
    }
    var brand = hit('[data-bb-brand]');
    if (brand) { pickBrand(brand); return; }

    var slot = hit('[data-bb-slot]');
    if (slot && S.brand) { openPanel(slot.getAttribute('data-bb-slot')); return; }

    var open = hit('[data-bb-open]');
    if (open && S.brand) { openPanel(open.getAttribute('data-bb-open')); return; }

    var rmx = hit('[data-bb-remove-x]');
    if (rmx) { S.xtra.splice(parseInt(rmx.getAttribute('data-bb-remove-x'), 10), 1); S.added = false; render(); return; }
    var rm = hit('[data-bb-remove]');
    if (rm) { delete S.picks[rm.getAttribute('data-bb-remove')]; S.added = false; render(); return; }

    if (hit('[data-bb-back]')) { closePanel(); return; } /* keeps the viewport on the rows; focus back on the opening row */
    if (hit('[data-bb-review]')) { closePanel(root.querySelector('.hodbb__summary')); return; } /* same close, landing on the summary card */

    var chip = hit('[data-bb-chip]');
    if (chip) {
      var cat = S.view, facet = chip.getAttribute('data-facet'), input = chip.getAttribute('data-input');
      S.chips[cat] = S.chips[cat] || {};
      S.chips[cat][facet] = S.chips[cat][facet] === input ? null : input;
      S.focusFacet = facet; S.focusInput = input;
      els.prods.innerHTML = '<div class="hodbb__loading">Loading models&hellip;</div>';
      loadPanel(cat);
      return;
    }
    if (hit('[data-bb-clearfilters]') || hit('[data-bb-clearfilters2]')) {
      S.chips[S.view] = {};
      S.focusClear = true;
      els.prods.innerHTML = '<div class="hodbb__loading">Loading models&hellip;</div>';
      loadPanel(S.view);
      return;
    }
    if (hit('[data-bb-retry]')) { loadPanel(S.view); return; }

    var add = hit('[data-bb-add]');
    if (add) {
      var prods = els.prods._prods || [];
      var p = prods[parseInt(add.getAttribute('data-bb-add'), 10)];
      if (!p) return;
      if (S.view === 'extras') {
        var xi = -1;
        for (var q = 0; q < S.xtra.length; q++) if (S.xtra[q].vid === p.vid) { xi = q; break; }
        if (xi > -1) { S.xtra.splice(xi, 1); S.added = false; render(); unmarkCard(add); }
        else {
          p.cat = 'extras'; S.xtra.push(p); S.added = false;
          closePanel(); /* rows scroll + focus back on the Extras row */
        }
        return;
      }
      var cur = S.picks[S.view];
      if (cur && cur.vid === p.vid) { delete S.picks[S.view]; S.added = false; render(); unmarkCard(add); }
      else {
        p.cat = S.view; S.picks[S.view] = p; S.added = false;
        closePanel(); /* rows scroll + focus back on the row that now shows the pick */
      }
      return;
    }

    var lm = hit('[data-bb-loadmore]');
    if (lm) { loadMore(lm.getAttribute('data-cursor'), lm); return; }

    var wp = hit('[data-bb-warrpick]');
    if (wp) {
      S.warr = parseInt(wp.getAttribute('data-bb-warrpick'), 10); S.added = false; S.warrOpen = false; render();
      var wcb = root.querySelector('[data-bb-warr-change]');
      if (wcb && !wcb.closest('[hidden]')) { try { wcb.focus({ preventScroll: true }); } catch (e) { wcb.focus(); } }
      var cta = root.querySelector('[data-bb-addcart]'); /* Stas: then it auto-scrolls to the add-to-cart */
      if (cta && cta.scrollIntoView) cta.scrollIntoView({ block: 'center', behavior: reduceMotion() ? 'auto' : 'smooth' });
      return;
    }
    if (hit('[data-bb-warr-change]')) {
      S.warrOpen = true; render();
      var onW = root.querySelector('[data-bb-warrpick].is-on');
      if (onW) { try { onW.focus({ preventScroll: true }); } catch (e) { onW.focus(); } }
      return;
    }

    var help = hit('[data-bb-help]');
    if (help) { openHelp(help.getAttribute('data-bb-help')); return; }
    if (hit('[data-bb-help-close]')) { root.querySelector('[data-bb-modal="help"]').hidden = true; return; }

    if (hit('[data-bb-addcart]') || hit('[data-bb-mob-addcart]')) { addToCart(); return; }
    if (hit('[data-bb-openquote]')) { openQuote(); return; }
    if (hit('[data-bb-quote-close]') || hit('[data-bb-quote-done]')) { root.querySelector('[data-bb-modal="quote"]').hidden = true; return; }
    if (hit('[data-bb-quote-send]')) { sendQuote(); return; }

    if (hit('[data-bb-reset-cancel]')) { root.querySelector('[data-bb-modal="reset"]').hidden = true; return; }
    if (hit('[data-bb-reset-confirm]')) {
      var m = root.querySelector('[data-bb-modal="reset"]');
      m.hidden = true;
      if (m._pending) applyBrand(m._pending);
      return;
    }

    /* click outside a modal closes it */
    var ov = t.classList && t.classList.contains('hodbb__overlay') ? t : null;
    if (ov) ov.hidden = true;
  });

  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-bb-quote-email]')) {
      root.querySelector('[data-bb-quote-send]').disabled = !/@/.test(e.target.value || '');
    }
  });

  render();
})();